import { putApi } from "./api_instance";

export const editBids = async (bidId, bidData, dispatch) => {
  try {
    return await putApi({
      apiUrl: `/projects/api/myBids/updateBid?bidId=${bidId}`,
      sendToken: true,
      dispatch,
      data: bidData,
    });
  } catch (error) {
    throw error;
  }
};
